import React from "react";
import { TaskExecutionNumber } from "./TaskExecutionNumber";
import { TaskExecutionOptions } from "./TaskExecutionOptions";
import { TaskExecutionText } from "./TaskExecutionText";
import { Prop } from "./PropAndRef";
import { graphql, useFragment } from "react-relay";

const TaskExecutionCMP = (props: Prop) => {
  const taskExecution = useFragment(
    graphql`
      fragment TaskExecutionComponent_TaskExecution on TaskExecution {
        ...TaskExecutionTextComponent
        ...TaskExecutionNumberComponent_TaskExecutionNumber
        ...TaskExecutionOptionsComponent
        __typename
      }
    `,
    props.taskExecution
  );

  switch (taskExecution.__typename) {
    case "TaskExecutionNumber": {
      return (
        <TaskExecutionNumber
          onFocus={props.onFocus}
          taskExecution={taskExecution}
          onNext={props.onNext}
          disabled={props.disabled}
        />
      );
    }

    case "TaskExecutionText":
      return (
        <TaskExecutionText
          onFocus={props.onFocus}
          taskExecution={taskExecution}
          onNext={props.onNext}
          disabled={props.disabled}
        />
      );
    case "TaskExecutionCheck":
      return (
        <TaskExecutionOptions
          onFocus={props.onFocus}
          taskExecution={taskExecution}
          onNext={props.onNext}
          disabled={props.disabled}
        />
      );
    default:
      return null;
  }
};

export const TaskExecutionComponent = React.memo(TaskExecutionCMP);
